<template>
  <div class="news">
    <m-banner :bg="banner.imgUrl" />
    <search-input />
    <nav-list />

    <div class="news-con center-box" :class="pi === 0 ? 'views-wrap' : 'news-wrap'" v-for="(pitem, pi) in blockList" :key="pi">
      <m-pane-title :title="pitem.tit" :sub-title="pitem.subTit" />
      <div class="list">
        <div class="item" v-for="item in (pi === 0 ? currentViewsData : currentNewsData)" :key="item.id">
          <div class="img">
            <img class="cov-img" :src="item.pcImgUrl" alt="">
          </div>
          <div class="msg">
            <p class="tit wrap-txt" @click="jumpDetail(item)">{{item.title}}</p>
            <p class="txt txt-align" :class="lang === 'en' ? 'en-txt-align' : ''">
              <span>
                {{lang === 'zh' ? item.description.substr(0, 41) : item.description.substr(0, 100)}} ...
              </span>
              <a
                  class="link-tag-small"
                  @click="jumpDetail(item)"
                  target="_blank"
                  v-if="item.jumpUrl"
              >&lsaquo;&nbsp;{{lang === 'zh' ? '详情' : 'More'}}&nbsp;&rsaquo;
              </a>
            </p>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="ifShowPage(pi)">
<!--        <div-->
<!--            @click="clickPageItem(pi, item)"-->
<!--            v-for="item in (pi === 0 ? viewPageNo : newsPageNo)"-->
<!--            :class="{-->
<!--              'page-item': true,-->
<!--              'active-item': isActive(pi, item)-->
<!--            }"-->
<!--        ></div>-->
        <el-pagination
            background
            layout="prev, pager, next"
            :current-page="pi === 0 ? currentViewsPage : currentNewsPage"
            :page-size="10"
            :pager-count="5"
            :total="pi === 0 ? viewsData.length : newsData.length"
            @current-change="(page) => onCurrentPageChange(pi, page)"
        ></el-pagination>
      </div>
    </div>
    <back-home />
  </div>
</template>

<script>

export default {
  name: "News",
  components: {
    // Pagination
  },
  data() {
    return {
      pageSize: 5,
      currentNewsPage: 1,
      currentViewsPage: 1,
      banner: [],
      newsData: [],
      viewsData: [],
      blockList: [
        {
          tit: '观点',
          subTit: 'Viewpoint'
        }, {
          tit: '新闻',
          subTit: 'News'
        }
      ]
    }
  },
  methods: {
    onCurrentPageChange(pi, page) {
      const className = pi === 0 ? 'views-wrap' : 'news-wrap';
      document.getElementsByClassName(className)[0].scrollIntoView({block: 'start'});
      if(pi === 0) {
        this.currentViewsPage = page;
      } else {
        this.currentNewsPage = page;
      }
    },
    ifShowPage(pi) {
      return pi === 0 ? this.viewPageNo > 1 : this.newsPageNo > 1;
    },
    clickPageItem(pi, i) {
      const className = pi === 0 ? 'views-wrap' : 'news-wrap';
      document.getElementsByClassName(className)[0].scrollIntoView({block: 'start'});
      if(pi === 0) {
        this.currentViewsPage = i;
      } else {
        this.currentNewsPage = i;
      }
    },
    isActive(pi, i) {
      let res = false;
      if(pi === 0) {
        return this.currentViewsPage === i;
      } else {
        return this.currentNewsPage === i
      }
    },
    jumpDetail(item) {
      const link = item.jumpUrl;
      if(link === 'local') {
        window.open('/mobile/detail/' + item.id + '?lang=' + this.lang);
      } else if(link) {
        window.open(link)
      }
      document.getElementById('app').scrollIntoView({ block: 'start' })
    },
    filterData(records) {
      this.viewsData = records['302'].sort((prev, next) => {
        return next.publishTime - prev.publishTime ;
      });

      this.newsData = records['301'].sort((prev, next) => {
        return next.publishTime - prev.publishTime ;
      });
    },
    getData(language) {
      this.$http.getOnlyContent({
        itemType: '3',
        platform: 'pc',
        language
      }).then(res => {
        this.filterData(res.crmOweContentMaps || {});
        this.banner = res.imageMaps['30'][0];
      });
    },
    getDataByLang(lang) {
      if(lang === 'zh') {
        this.getData('china');
      } else {
        this.getData('english');
      }
    },
    getBanner() {
      this.$http.getOnlyContent({
        itemType: '3',
        platform: 'mb',
        language: this.lang === 'zh' ? 'china' : 'english'
      }).then(res => {
        this.banner = res.imageMaps['30'][0];
      });
    }
  },
  computed: {
    lang() {
      return this.$store.state.mlang;
    },
    newsPageNo() {
      return Math.ceil(this.newsData.length / this.pageSize);
    },
    viewPageNo() {
      return Math.ceil(this.viewsData.length / this.pageSize);
    },
    currentViewsData() {
      const start = (this.currentViewsPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.viewsData.slice(start, end)
    },
    currentNewsData() {
      const start = (this.currentNewsPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.newsData.slice(start, end)
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler(v) {
        this.getDataByLang(v);
      }
    }
  },
  created() {
    this.getBanner();
  }
}
</script>

<style lang="less">
@import "../../common/theme";
@n-size-1: calc(@mobileFont * .55);
.mobile-home {
  .news {
    .el-pagination {
      padding-left: 0;
      padding-right: 0;
    }
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li {
      margin-left: 2px;
      margin-right: 4px;
    }
    .el-pagination.is-background .el-pager li:not(.disabled).active {
      background-color: #037698;
    }
    .news-con {
      .list {
        .item {
          display: flex;
          justify-content: space-between;
          margin-bottom: 15px;
          &:last-child {
            margin-bottom: 50px;
          }
          .img {
            img {
              width: 100px;
              height: 100px;
            }
          }
          .msg {
            width: calc(100% - 110px);
            .tit {
              margin-bottom: 3px;
              font-weight: bolder;
              color: #037698;
            }
            .txt {
              text-indent: 2em;
            }
          }
          & ~ .item {
            padding-top: 15px;
            border-top: 1px solid #d2d2d2;
          }
        }
      }
      .pagination {
        margin: 60px 0 100px;
        text-align: right;
        .page-item {
          width: 14px;
          height: 14px;
          border: 1px solid #037698;
          border-radius: 50%;
          display: inline-block;
          margin: 0 6px;
          cursor: pointer;
        }
        .active-item {
          background: #037698;
        }
      }
    }
  }
}
</style>
